import { Injectable, inject } from "@angular/core";
import type { Observable } from "rxjs/internal/Observable";
import { shareReplay } from "rxjs/operators";
import { AccountService } from "../../core";
import type { IFirmInfo } from "../../shared/model/firm-info.model";

@Injectable({ providedIn: "root" })
export class DefaultLayoutService {
    private accountService = inject(AccountService);

    firmInfo$: Observable<IFirmInfo> = this.accountService
        .getFirmInfo()
        .pipe(shareReplay(1));
}
